import type { BLACK_MASS } from '~/constants/services/constants'
import type { TMarketServiceConfig } from '~/src/types/markets'

type TMarketInsightsTabs = {
  market: string
  hideCriticalInsights?: boolean
}

export const getMarketInsightsTabs = ({ market }: TMarketInsightsTabs) => {
  const baseUrl = `/${market}/market-insights`
  return [
    {
      name: 'Analysis',
      slug: 'analysis',
      url: `${baseUrl}/analysis`,
      hide: false,
    },
    {
      name: 'Briefings',
      slug: 'briefings',
      url: `${baseUrl}/briefings`,
      hide: false,
    },
    {
      name: 'Critical Insights',
      slug: 'critical-insights',
      url: `${baseUrl}/critical-insights`,
      hide: false,
    },
    { name: 'Videos', slug: 'videos', url: `${baseUrl}/videos`, hide: false },
  ].filter((tab) => !tab.hide)
}

type TMarketSustainabilityTab = {
  market: string
  hideOverview?: boolean
  hideBatteryEmissions?: boolean
}

export const getSustainabilityTabs = ({
  market,
  hideOverview = false,
  hideBatteryEmissions = false,
}: TMarketSustainabilityTab) => {
  const baseUrl = `/${market}/sustainability`
  return [
    {
      name: 'Overview',
      slug: 'overview',
      url: `${baseUrl}/overview`,
      hide: hideOverview,
    },
    {
      name: 'Sustainability Index',
      slug: 'sustainability-index',
      url: `${baseUrl}/sustainability-index`,
      hide: false,
    },
    {
      name: 'Battery Emissions Analyser',
      mobileName: 'BEA',
      slug: 'battery-emissions-analyser',
      url: `${baseUrl}/battery-emissions-analyser`,
      hide: hideBatteryEmissions,
    },
    {
      name: 'LCA',
      slug: 'lca',
      url: `${baseUrl}/lca`,
      hide: false,
    },
  ].filter((tab) => !tab.hide)
}

type TPricesTabs = {
  market: TMarketServiceConfig | typeof BLACK_MASS
  hideIndexTab?: boolean
  hideCustomisationToolTab?: boolean
}

export const getPricesTabs = ({
  market,
  hideIndexTab = false,
  hideCustomisationToolTab = false,
}: TPricesTabs) => {
  const isBlackMass = market.slug === 'black-mass'
  const isLithiumIonBatteries = market.slug === 'lithium-ion-batteries'

  let slugBase: string = market.slug

  if (isLithiumIonBatteries) {
    slugBase = market.alternativeSlug
  }

  if (isBlackMass) {
    slugBase = market.serviceBasePath
  }

  const slugMarket =
    isBlackMass || isLithiumIonBatteries ? `${market.slug}-` : ''
  const baseUrl = `/${slugBase}/${slugMarket}prices`

  return [
    {
      name: 'Table',
      slug: null,
      url: `${baseUrl}`,
      hide: false,
    },
    {
      name: 'Chart',
      slug: 'chart',
      url: `${baseUrl}/chart`,
      hide: false,
    },
    {
      name: 'Index',
      slug: 'index',
      hide: hideIndexTab,
      url: `${baseUrl}/index`,
    },
    {
      name: 'Price Customisation Tool',
      slug: 'price-customisation-tool',
      hide: hideCustomisationToolTab,
      url: `${baseUrl}/price-customisation-tool`,
    },
  ].filter((tab) => !tab.hide)
}
